<template>
  <b-container>
    <h1>Liste des agents</h1>
    <b-button variant="primary" class="mb-4 mt-4" v-b-modal.addUserModal>
      Ajouter un nouvel agent
    </b-button>

    <UserTable ref="userTable"/>


    <b-modal @submit.prevent="addUser" centered hide-footer id="addUserModal" title="Ajout d'un nouvel agent">
      <template slot="default">
        <p>Veuillez utiliser le formulaire suivant pour ajouter un agent :</p>

        <b-form @submit="addUser">
          <b-form-group label="Nom" label-cols="3">
            <b-form-input placeholder="Nom" v-model="user.lastName" required/>
          </b-form-group>

          <b-form-group label="Prénom" label-cols="3">
            <b-form-input placeholder="Prénom" v-model="user.firstName" required/>
          </b-form-group>

          <b-form-group label="Email" label-cols="3">
            <b-form-input type="email" placeholder="Email" v-model="user.email" required/>
          </b-form-group>

          <b-form-group label="Compte actif ?" label-cols="3">
            <b-form-checkbox v-model="user.isActive" switch/>
          </b-form-group>

          <b-form-group label="Profil(s)" id="rolesCheckboxes" label-cols="3">
            <b-checkbox-group v-model="user.roles" :state="checkboxGroupValidated">
              <b-form-checkbox value="ROLE_AGENT">Agent</b-form-checkbox>
              <b-form-checkbox value="ROLE_AGENCY">Agence</b-form-checkbox>
              <b-form-checkbox value="ROLE_ADMIN">Administrateur</b-form-checkbox>
            </b-checkbox-group>
          </b-form-group>

          <b-row align-v="center">
            <b-col align-self="center" class="text-center">
              <b-button type="submit" variant="primary">Ajouter l'utilisateur</b-button>
            </b-col>
            <b-col align-self="center" class="text-center">
              <b-button variant="danger" @click="$bvModal.hide('addUserModal')">Annuler</b-button>
            </b-col>
          </b-row>
        </b-form>
      </template>

    </b-modal>

  </b-container>
</template>

<script>
export default {
  name: 'Admin',
  data() {
    return {
      user: {
        firstName: null,
        lastName: null,
        email: null,
        isActive: true,
        roles: [],
      },
      checkboxGroupValidated: null,
    };
  },
  methods: {
    addUser(event) {
      event.preventDefault();

      // At lease one role has to be checked
      if (this.user.roles.length === 0) {
        this.checkboxGroupValidated = false;
      } else {
        axios.post('users', {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          email: this.user.email,
          roles: this.user.roles,
          isActive: this.user.isActive,
          password: Math.random().toString(36).substring(2),
        })
            .then((response) => {
              this.$refs.userTable.addUser(response.data);
              this.$bvModal.hide('addUserModal');

              const toast = {
                show: true,
                message: 'Utilisateur ajouté avec succès !',
                variant: 'success',
                duration: 3000,
              };

              this.$store.commit('setGlobalToaster', toast);

              // Forcing password reset process
              let formData = new FormData();
              formData.append('email', this.user.email);

              axios.post('users/reset/password', formData)
                .then(() => {
                  // Show success toast
                  const toast = {
                    show: true,
                    message: 'Email de récupération de mot de passe envoyé !',
                    variant: 'success',
                    duration: 3000,
                  };
                  this.$store.commit('setGlobalToaster', toast);
                })
                .catch((error) => {
                  console.error(error);
                })
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 400) {
                  let errorMessage = '';
                  let i = 0;
                  if (error.response.data.length = 1) {
                    errorMessage = error.response.data[0].message;
                  } else {
                    error.response.data.forEach((message) => {
                      errorMessage = errorMessage + ' - ' + message.message;
                    });
                  }

                  const toast = {
                    show: true,
                    message: errorMessage,
                    variant: 'danger',
                    duration: 3000,
                  };

                  this.$store.commit('setGlobalToaster', toast);
                }
              } else {
                console.error(error);
              }
            })
            .finally(() => {
              this.user = {
                firstName: null,
                lastName: null,
                email: null,
                isActive: true,
              };
            });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .admin-container {
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/Admin.vue